var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { CustomFormElementType } from '../enums/custom-form-element-type.enum.js';
class CustomFormElementOptionDto {
    id;
    value;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementOptionDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementOptionDto.prototype, "value", void 0);
/**
 * Response DTO for CustomFormElement queries.
 * This is independent of the Domain Entity and optimized for the view.
 *
 * @remarks
 * Use this DTO instead of `CustomFormElementFullSizeDto` or `CustomFormElement` entity.
 * Those are deprecated in favor of dedicated Response DTOs.
 */
export class CustomFormElementResponseDto {
    id;
    createdAt;
    updatedAt;
    label;
    index;
    options;
    mandatory;
    type;
    customFormId;
    customFormSectionId;
    imageFilename;
    /** Helper text under the question label (all types). `null` = not authored. */
    description;
    /** In-field hint; only ever set on the two text types. */
    placeholder;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormElementResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormElementResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementResponseDto.prototype, "label", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], CustomFormElementResponseDto.prototype, "index", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormElementOptionDto),
    __metadata("design:type", Array)
], CustomFormElementResponseDto.prototype, "options", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], CustomFormElementResponseDto.prototype, "mandatory", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementResponseDto.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementResponseDto.prototype, "customFormId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormElementResponseDto.prototype, "customFormSectionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], CustomFormElementResponseDto.prototype, "imageFilename", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], CustomFormElementResponseDto.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], CustomFormElementResponseDto.prototype, "placeholder", void 0);
//# sourceMappingURL=custom-form-element.response.dto.js.map